'use client'

import { useState } from 'react'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Container } from '@/components/shared/container'
import { navigation, siteConfig } from '@/data/site-data'
import Link from 'next/link'
import { motion } from 'framer-motion'

export default function Header() {
  const navItemVariant = {
    hidden: { opacity: 0, y: -10 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.1 * i, duration: 0.4 },
    }),
  }

  return (
    <header className="fixed w-full z-50 transition-all duration-500 border-bx xl:border-r backdrop-blur-3xl bg-background/90 shadow-2xl shadow-background h-24 flex items-center justify-center">
      <Container className='w-full max-w-full p-0'>
        <div className="flex items-center justify-between h-16">
          {/* Logo + Site Name */}
          <motion.div
            className="flex items-center space-x-3 group cursor-pointer border-rx h-16 pl-4 xl:pl-4 pr-10 xl:pr-20"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className='h-9 w-9 relative '>
              <img src="/svg/logo.svg" className='h-9 w-9 absolute blur-md opacity-50' />
              <img src="/svg/logo.svg" className='h-9 w-9 absolute' />
            </div>
            <span className="font-brand text-3xl text-foreground">{siteConfig.name}</span>
          </motion.div>

          {/* Desktop Navigation */}
          <nav className="w-full hidden xl:flex items-center">
            {navigation.map((item, idx) => (
              <motion.div
                key={item.name}
                custom={idx}
                initial="hidden"
                animate="visible"
                variants={navItemVariant}
              >
                <Link
                  href={item.href}
                  className="tracking-[-0.2px] overflow-hidden relative text-muted-foreground border-rx h-16 flex items-center hover:px-12 ease-in-out duration-300 transition-all px-3.5 text-[0.9rem] hover:text-foreground font-light group"
                >
                  <div className='absolute h-full group-hover:w-full ease-in-out duration-400 w-0 bg-linear-to-r to-transparent blur-sm opacity-40 from-foreground/40 left-0 -z-10' />
                  {item.name}
                </Link>
              </motion.div>
            ))}

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className='ml-auto'
            >
              <Link href={`mailto:${siteConfig.email}`}>
                <Button size="lg" className="shadow-lg rounded-full shadow-primary/25 bg-white hover:bg-white">
                  Get Started
                </Button>
              </Link>
            </motion.div>
          </nav>
        </div>
      </Container>
    </header>
  )
}